import { Box, CircularProgress } from "@mui/material";

const CircularLoader = ({ color }) => {
    return (
        <Box sx={{ textAlign: "center" }}>
            <CircularProgress color={color ? color : "secondary"} />
        </Box>
    )
};
export default CircularLoader;